import * as _ from 'lodash';
import ITableField = ZoneIQCalibration.ITableField;

export class TableField implements ITableField {
    public Id: number;
    public Field: string;
    public TableType: number;
    public FieldType: number;
    public Hide: boolean;
    public FieldSection: string;
    public ViewOrder: number;

    constructor(data: ITableField) {
        Object.assign(
            this,
            _.pick(data, [
                'Id',
                'Field',
                'TableType',
                'FieldType',
                'Hide',
                'FieldSection',
                'ViewOrder',
                'importValidationResult'
            ])
        );
    }

    static factory(data: ITableField) {
        return new TableField(data);
    }
}
